import script from "./CustDataPetRecordTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustDataPetRecordTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./CustDataPetRecordTableRow.vue?vue&type=style&index=0&id=4107e296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4107e296"]])

export default __exports__